import axios from '../../utils/axios';
import { objectToFormData } from '../utils';

export async function getDashboardData() {
  const response = await axios.get('/Dashboard');
  return response;
}

// GET /Api/Notifications
export async function getNotifications() {
  const response = await axios.get('/Notifications');
  return response;
}

// GET /Api/Notifications/Count
export async function getNotificationCount() {
  const response = await axios.get('/Notifications/Count');
  return response;
}

// /Api/SiteSwitch siteId post
export async function postSiteSwitch(siteId) {
  const response = await axios.post(`/SiteSwitch/?siteId=${siteId}`);
  return response;
}

export async function getUsersRentalInfoForFacility() {
  const response = await axios.get('/GetUsersRentalInfoForFacility');
  return response;
}

// GET /Api/UnreadSystemMessages
export async function getUnreadSystemMessages() {
  const response = await axios.get('/UnreadSystemMessages');
  return response;
}
// GET /Api/NavMessages
export async function getNavMessages() {
  const noCacheConfig = {
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
      Expires: '0',
    },
    params: { _: Date.now() },
  };

  const response = await axios.get('/NavMessages');
  if (response.status === 200 && !response.request.responseURL.toLowerCase().endsWith("navmessages"))
  {
    const noCacheResponse = await axios.get('/NavMessages', noCacheConfig);
    return noCacheResponse;
  }
  return response;
}

// POST /Api/MarkAsReadSystemMessages;  ids array[integer]
export async function markAsReadSystemMessages(ids) {
  const response = await axios.post(
    '/MarkAsReadSystemMessages',
    objectToFormData({
      ids,
    })
  );
  return response;
}
